import ThemeOverrideProps from 'ThemeOverrideProps';
import {StyleSheet} from 'react-native';
const {fontRegular, fontExtraBold} = ThemeOverrideProps.sheetStyles;

export const styles = StyleSheet.create({
  confetti: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  bodyText: {
    fontSize: 16,
    lineHeight: 24,
    color: '#000',
    textAlign: 'center',
  },
});

export const customModalStyles = StyleSheet.create({
  mainContainer: {
    width: 315,
  },

  title: {
    marginTop: 16,
  },

  primaryButton: {
    backgroundColor: '#4990E2',
    fontSize: 15,
  },

  modalTitleText: {
    ...fontExtraBold,
    fontSize: 20,
    lineHeight: 24,
    letterSpacing: -0.03,
    textAlign: 'center',
    color: '#070707',
  },

  modalBodyText: {
    ...fontRegular,
    fontSize: 13,
    lineHeight: 18,
    letterSpacing: -0.01,
    marginTop: 16,
    textAlign: 'center',
    color: '#070707',
  },
});
